(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6132],{

/***/ 67432:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/templates/quizTemplatePage",
      function () {
        return __webpack_require__(14699);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 59618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ WhitePanel; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(47842);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2902);





function WhitePanel(param) {
    var children = param.children, className = param.className, _ignorePadding = param.ignorePadding, ignorePadding = _ignorePadding === void 0 ? false : _ignorePadding, _ignoreVertical = param.ignoreVertical, ignoreVertical = _ignoreVertical === void 0 ? false : _ignoreVertical, _borderSizing = param.borderSizing, borderSizing = _borderSizing === void 0 ? "rounded-[12px]" : _borderSizing;
    var isMobile = (0,_hooks_useIsMobile__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var _obj;
    var classNames = classnames__WEBPACK_IMPORTED_MODULE_2___default()("bg-white border-gray-200 border mb-3 text-passport ".concat(isMobile ? "min-w-[280px]" : "", " "), borderSizing, className, (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "px-3 sm:px-4 md:px-10", !ignorePadding), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_obj, "py-8", !ignoreVertical), _obj));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classNames,
        children: children
    });
}
function PanelTitle(param) {
    var children = param.children, className = param.className, _defaultMargin = param.defaultMargin, defaultMargin = _defaultMargin === void 0 ? "mb-2" : _defaultMargin, _textClassName = param.textClassName, textClassName = _textClassName === void 0 ? "text-lg text-passport" : _textClassName;
    var classNames = classnames__WEBPACK_IMPORTED_MODULE_2___default()(defaultMargin, className);
    var textClass = classnames__WEBPACK_IMPORTED_MODULE_2___default()(textClassName);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classNames,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
            className: textClass,
            children: children
        })
    });
}
function PanelSubtitle(param) {
    var children = param.children, _className = param.className, className = _className === void 0 ? "text-sm" : _className;
    var classNames = classnames__WEBPACK_IMPORTED_MODULE_2___default()((0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, className, className));
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "mb-6 text-sm text-passport",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
            className: classNames,
            children: children
        })
    });
}
function PanelContent(param) {
    var children = param.children, className = param.className;
    var classNames = classnames__WEBPACK_IMPORTED_MODULE_2___default()("w-full flex flex-grow text-passport", className);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classNames,
        children: children
    });
}
function PanelHeadDivider(param) {
    var children = param.children, className = param.className;
    var classNames = classnames__WEBPACK_IMPORTED_MODULE_2___default()("flex justify-between pb-5 border-b border-gray-200 text-passport", className);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: classNames,
        children: children
    });
}
WhitePanel.Title = PanelTitle;
WhitePanel.Subtitle = PanelSubtitle;
WhitePanel.Content = PanelContent;
WhitePanel.HeadDivider = PanelHeadDivider;


/***/ }),

/***/ 92483:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "k": function() { return /* binding */ UpgradeModal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _components_base_overlays_Modal_SimpleModal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18235);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2784);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);




function UpgradeModal(param) {
    var feature = param.feature, isOwner = param.isOwner;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base_overlays_Modal_SimpleModal__WEBPACK_IMPORTED_MODULE_1__/* .SimpleModal */ .Y, {
        type: "upgrade",
        title: feature == "course" ? "Access Restricted" : isOwner ? "You’ve reached your plans limit" : "Contact the course owner",
        body: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: feature == "course" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "px-16",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    children: isOwner ? "Access to this course is temporarily restricted. Please upgrade your plan to regain access." : "Access to this course is temporarily restricted. Please contact the course owner for further details."
                })
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "px-16",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        children: [
                            "You've reached the maximum number of",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "font-medium mx-1",
                                children: featureToString(feature)
                            }),
                            "that can be added to",
                            feature === "courses" ? " your account" : " this course",
                            !isOwner && " based on the course owner's plan"
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    isOwner ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                        children: [
                            "But don't let that stop you from sharing your knowledge with students.",
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                href: "/account/billing",
                                className: "underline mx-1 hover:text-teal-600",
                                children: "Upgrade"
                            }),
                            "for higher limits and other great features."
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: "Please contact the course owner to upgrade their plan and increase course limits."
                    })
                ]
            })
        }),
        confirmLabel: feature == "course" && !isOwner ? "Okay" : "View Plans",
        cancelLabel: feature == "course" && !isOwner ? null : "Cancel",
        onConfirm: function() {
            router.push("/account/billing", undefined, {
                shallow: true
            });
        }
    });
}
function featureToString(feature) {
    switch(feature){
        case "students":
            return "students";
        case "leaders":
            return "course leaders";
        case "activities":
            return "Assignments and Quizzes";
        case "courses":
            return "new courses";
    }
}


/***/ }),

/***/ 14699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ QuizTemplatePage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(87394);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var sanitize_html__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(24330);
/* harmony import */ var sanitize_html__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(sanitize_html__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96577);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(28879);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _graphql_graphql_client_graphClient__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(52789);
/* harmony import */ var _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78616);
/* harmony import */ var _utils_capitalizeFirst__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(54230);
/* harmony import */ var _components_context_UniversalModalContext__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47614);
/* harmony import */ var _components_common_panels_WhitePanel__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(59618);
/* harmony import */ var _skipper_ui__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(23357);
/* harmony import */ var _components_modals_useActivityTemplateModal_UseActivityTemplateModal__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(71191);
/* harmony import */ var _components_common_svgs_QuizIconSVG__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(19313);
/* harmony import */ var _hooks_useEnrollmentsWithMapping__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(7989);
/* harmony import */ var _headlessui_react__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(39708);
/* harmony import */ var _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(54933);
/* harmony import */ var _fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(49929);
/* harmony import */ var _hooks_user_useDefaultSession__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(82056);
/* harmony import */ var _components_base__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(34867);
/* harmony import */ var _hooks_modals_useDeleteTemplate__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(50446);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(82066);
/* harmony import */ var _components_activities_sharedItems__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(5845);
/* harmony import */ var _components_common_loading_SimpleSpinner__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(20444);



























function QuizTemplatePage() {
    var ref;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)((0,_hooks_user_useDefaultSession__WEBPACK_IMPORTED_MODULE_14__/* .useUserSession */ .EC)(), 1), user = ref1[0];
    var query = router.query;
    var id = query.id;
    var toggle = (0,_components_context_UniversalModalContext__WEBPACK_IMPORTED_MODULE_7__/* .useUniversalModalDispatch */ .Xt)().toggle;
    var ref2 = (0,_graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_6__/* .useQuizTemplatesQuery */ .Xjx)((0,_graphql_graphql_client_graphClient__WEBPACK_IMPORTED_MODULE_5__/* .getClient */ .s3)("templates"), {
        ids: [
            id.toString()
        ]
    }), data = ref2.data, isLoading = ref2.isLoading, isFetching = ref2.isFetching;
    var ref3;
    var ref4 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)((ref3 = data === null || data === void 0 ? void 0 : data.quizTemplates) !== null && ref3 !== void 0 ? ref3 : [], 1), template = ref4[0];
    var ref5 = (0,_hooks_useEnrollmentsWithMapping__WEBPACK_IMPORTED_MODULE_12__/* .useEnrollHandler */ .fe)(), leadingCourses = ref5.enrolls.leadingCourses, coursesDataLoading = ref5.loading;
    var queryClient = (0,react_query__WEBPACK_IMPORTED_MODULE_17__.useQueryClient)();
    var onQuizSuccess = function(data) {
        queryClient.invalidateQueries("QuizTemplates", {
            refetchInactive: true,
            refetchActive: true
        });
        router.push("/templates");
    };
    var modalParams = (0,_hooks_modals_useDeleteTemplate__WEBPACK_IMPORTED_MODULE_16__/* .useDeleteTemplate */ .$)({
        // onCourseSuccess,
        // onAssignmentSuccess,
        onQuizSuccess: onQuizSuccess
    });
    var deleteModalProps = modalParams.deleteModalProps;
    if (isLoading) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "py-20",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_loading_SimpleSpinner__WEBPACK_IMPORTED_MODULE_19__/* .SimpleSpinner */ .I, {})
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full h-full overflow-scroll",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex justify-center w-full p-20",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_common_panels_WhitePanel__WEBPACK_IMPORTED_MODULE_8__/* .WhitePanel */ .x, {
                    className: "w-[70%] max-w-[800px] mb-0 h-auto pt-8",
                    ignorePadding: true,
                    ignoreVertical: true,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "px-6",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-sm text-gray-500 hover:text-gray-700 cursor-pointer font-500",
                                    onClick: function() {
                                        return router.push("/templates");
                                    },
                                    children: "< Back to templates"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "flex justify-between gap-x-2 mt-2",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex gap-x-2 items-center mt-2",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_svgs_QuizIconSVG__WEBPACK_IMPORTED_MODULE_11__/* .QuizIconSVG */ .p, {
                                                    className: "w-6 h-6"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                    className: "text-2xl font-medium",
                                                    children: template === null || template === void 0 ? void 0 : template.title
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex gap-x-2 items-center mt-2",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_skipper_ui__WEBPACK_IMPORTED_MODULE_9__/* .Button */ .zx, {
                                                    size: "medium",
                                                    variant: "primary",
                                                    className: "py-2",
                                                    type: "button",
                                                    onClick: function() {
                                                        var ref;
                                                        return toggle(true, /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_modals_useActivityTemplateModal_UseActivityTemplateModal__WEBPACK_IMPORTED_MODULE_10__/* .UseActivityTemplateModal */ .D, {
                                                            originalCourseId: template === null || template === void 0 ? void 0 : (ref = template.templateInCourse) === null || ref === void 0 ? void 0 : ref.id,
                                                            templateTitle: template === null || template === void 0 ? void 0 : template.title,
                                                            templateId: parseInt(template === null || template === void 0 ? void 0 : template.id),
                                                            coursesList: leadingCourses,
                                                            setLoad: function() {},
                                                            isQuiz: true
                                                        }));
                                                    },
                                                    children: "Use template"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                    children: (user === null || user === void 0 ? void 0 : user.id) === (template === null || template === void 0 ? void 0 : (ref = template.author) === null || ref === void 0 ? void 0 : ref.id) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_headlessui_react__WEBPACK_IMPORTED_MODULE_21__/* .Menu */ .v, {
                                                        as: _skipper_ui__WEBPACK_IMPORTED_MODULE_9__/* .MenuContainer */ .Fe,
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_21__/* .Menu.Button */ .v.Button, {
                                                                as: _skipper_ui__WEBPACK_IMPORTED_MODULE_9__/* .Button */ .zx,
                                                                variant: "textOnlyDark",
                                                                size: "medium",
                                                                className: "gap-x-2",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_skipper_ui__WEBPACK_IMPORTED_MODULE_9__/* .Button */ .zx, {
                                                                    size: "medium",
                                                                    variant: "white",
                                                                    className: "py-2",
                                                                    type: "button",
                                                                    onClick: function() {},
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_fortawesome_react_fontawesome__WEBPACK_IMPORTED_MODULE_13__/* .FontAwesomeIcon */ .G, {
                                                                        icon: _fortawesome_pro_solid_svg_icons__WEBPACK_IMPORTED_MODULE_22__/* .faEllipsis */ .S6C
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_21__/* .Menu.Items */ .v.Items, {
                                                                as: _skipper_ui__WEBPACK_IMPORTED_MODULE_9__/* .MenuItemContainer */ .s8,
                                                                css: {
                                                                    mt: "0px"
                                                                },
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_headlessui_react__WEBPACK_IMPORTED_MODULE_21__/* .Menu.Item */ .v.Item, {
                                                                    children: function(param) {
                                                                        var active = param.active;
                                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_skipper_ui__WEBPACK_IMPORTED_MODULE_9__/* .MenuFieldItem */ .E_, {
                                                                            active: active,
                                                                            onClick: modalParams.onClick,
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                className: "flex w-full items-center gap-x-2",
                                                                                children: "Delete template"
                                                                            })
                                                                        });
                                                                    }
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TemplateContent, {
                            template: template
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_base__WEBPACK_IMPORTED_MODULE_15__/* .Modal */ .u_, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)({
                onConfirm: function() {
                    modalParams.onConfirm(parseInt(template === null || template === void 0 ? void 0 : template.id), "QuizTemplate");
                },
                onCancel: modalParams.onCancel,
                open: modalParams.open,
                setOpen: function() {
                    return modalParams.setOpen;
                }
            }, deleteModalProps))
        ]
    });
};
var TemplateContent = function(param) {
    var template = param.template;
    var templateTabs = [
        {
            id: "questions",
            title: "Questions"
        },
        {
            id: "about",
            title: "About"
        }, 
    ];
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(templateTabs[0]), currentTab = ref[0], setCurrentTab = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex w-full justify-start items-center gap-x-4 border-b border-gray-200 px-6",
                children: templateTabs.map(function(option) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        onClick: function() {
                            return setCurrentTab(option);
                        },
                        className: "py-4 px-1 text-sm flex items-center gap-x-2 cursor-pointer ".concat(currentTab.id === option.id ? "text-teal-600 border-b-2 border-teal-600" : "text-gray-500"),
                        children: option.title
                    }, option.id);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "w-full h-content",
                children: [
                    currentTab.id === "questions" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(QuestionsTab, {
                        template: template
                    }),
                    currentTab.id === "about" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AboutTab, {
                        template: template
                    }),
                    currentTab.id === "sources" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(SourcesTab, {
                        template: template
                    })
                ]
            })
        ]
    });
};
var QuestionsTab = function(param) {
    var template = param.template;
    var ref;
    var ImageArray = _components_activities_sharedItems__WEBPACK_IMPORTED_MODULE_18__/* .QuizImageArray */ .Ti;
    var instructions = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        if (!(template === null || template === void 0 ? void 0 : template.instructions)) return "";
        return sanitize_html__WEBPACK_IMPORTED_MODULE_24___default()(template.instructions, {
            allowedTags: sanitize_html__WEBPACK_IMPORTED_MODULE_24___default().defaults.allowedTags.concat([
                "iframe",
                "img",
                "p",
                "span"
            ]),
            allowedAttributes: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_25__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)({}, (sanitize_html__WEBPACK_IMPORTED_MODULE_24___default().defaults.allowedAttributes)), {
                iframe: [
                    "*"
                ],
                img: [
                    "*"
                ],
                p: [
                    "*"
                ],
                span: [
                    "*"
                ]
            })
        });
    }, [
        template
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "px-6 ".concat(!!instructions ? "py-4" : ""),
                dangerouslySetInnerHTML: {
                    __html: instructions
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex flex-col border border-gray-200 rounded-lg",
                children: template === null || template === void 0 ? void 0 : (ref = template.questions) === null || ref === void 0 ? void 0 : ref.map(function(question, index) {
                    var ref, ref1, ref2;
                    var isEven = index % 2 === 0;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex gap-x-3 items-center w-full py-6 px-6 ".concat(!isEven ? "bg-white" : "bg-gray-50"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                src: ((ref = ImageArray.find(function(image) {
                                    return (image === null || image === void 0 ? void 0 : image.blockType) === (question === null || question === void 0 ? void 0 : question.questionType);
                                })) === null || ref === void 0 ? void 0 : ref.imgMini) || "",
                                layout: "fixed",
                                width: 25,
                                height: 25
                            }),
                            (question === null || question === void 0 ? void 0 : question.questionType) !== "fill" ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "",
                                dangerouslySetInnerHTML: {
                                    __html: question === null || question === void 0 ? void 0 : (ref1 = question.content) === null || ref1 === void 0 ? void 0 : ref1.statement
                                }
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "",
                                dangerouslySetInnerHTML: {
                                    __html: question === null || question === void 0 ? void 0 : (ref2 = question.content) === null || ref2 === void 0 ? void 0 : ref2.begin
                                }
                            })
                        ]
                    }, "question_".concat(index));
                })
            })
        ]
    });
};
var AboutTab = function(param) {
    var template = param.template;
    var ref, ref1, ref2, ref3, ref4;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    var visibleTo = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (template === null || template === void 0 ? void 0 : template.visibleTo) === _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_6__/* .Visibility.Me */ .EEb.Me ? "Just me" : (0,_utils_capitalizeFirst__WEBPACK_IMPORTED_MODULE_26__/* .capitalizeFirstLetter */ .f)(template === null || template === void 0 ? void 0 : template.visibleTo);
    }, [
        template
    ]);
    var copyableBy = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return (template === null || template === void 0 ? void 0 : template.copyableBy) === _graphql_generated_graphql__WEBPACK_IMPORTED_MODULE_6__/* .Visibility.Me */ .EEb.Me ? "Just me" : (0,_utils_capitalizeFirst__WEBPACK_IMPORTED_MODULE_26__/* .capitalizeFirstLetter */ .f)(template === null || template === void 0 ? void 0 : template.copyableBy);
    }, [
        template
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "mt-6 px-6 pb-8",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                    className: "text-lg font-medium",
                    children: "License"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "grid grid-cols-8 mt-6",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "col-span-4 flex flex-col",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-sm text-gray-700 mb-1",
                                    children: "Visible To"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: (0,_utils_capitalizeFirst__WEBPACK_IMPORTED_MODULE_26__/* .capitalizeFirstLetter */ .f)(visibleTo)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "col-span-4 flex flex-col",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-sm text-gray-700 mb-1",
                                    children: "Copyable by"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: (0,_utils_capitalizeFirst__WEBPACK_IMPORTED_MODULE_26__/* .capitalizeFirstLetter */ .f)(copyableBy)
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "grid grid-cols-8 mt-6",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "col-span-4 flex flex-col",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-sm text-gray-700 mb-1",
                                    children: "Date created"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: dayjs__WEBPACK_IMPORTED_MODULE_4___default()(template === null || template === void 0 ? void 0 : template.createdAt).format("MMMM D, YYYY")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "col-span-4 flex flex-col",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    className: "text-sm text-gray-700 mb-1",
                                    children: "Updated"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                    children: dayjs__WEBPACK_IMPORTED_MODULE_4___default()(template === null || template === void 0 ? void 0 : template.createdAt).format("MMMM D, YYYY")
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "grid grid-cols-8 mt-6",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "col-span-4 flex flex-col",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-sm text-gray-700 mb-1",
                                children: "Created by"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex gap-x-2 items-center text-gray-700",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_skipper_ui__WEBPACK_IMPORTED_MODULE_9__/* .SkipperAvatar */ .dd, {
                                        initials: template === null || template === void 0 ? void 0 : (ref = template.author) === null || ref === void 0 ? void 0 : ref.initials,
                                        calendarColor: template === null || template === void 0 ? void 0 : (ref1 = template.author) === null || ref1 === void 0 ? void 0 : ref1.calendarColor,
                                        imageUrl: template === null || template === void 0 ? void 0 : (ref2 = template.author) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.imageFileEntry) === null || ref3 === void 0 ? void 0 : ref3.url,
                                        size: "medium"
                                    }),
                                    template === null || template === void 0 ? void 0 : (ref4 = template.author) === null || ref4 === void 0 ? void 0 : ref4.fullName
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var SourcesTab = function(param) {
    var template = param.template;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {});
};
QuizTemplatePage.useDefault = true;


/***/ }),

/***/ 70764:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 45158:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 58635:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 30139:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4330,5423,9774,2888,179], function() { return __webpack_exec__(67432); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);